export enum VirtualizedListItemType {
	sport = "sport",
	groupByTournament = "grouped-by-tournament",
	tournamentToggle = "tournament-toggle",
	primaryEvent = "primary-event",
	secondaryEvent = "secondary-event",
}
